import { TextField } from '@mui/material';
import { Controller, FieldError, FieldValues, UseControllerProps } from 'react-hook-form';

interface CampaignDateTimePickerProps<T extends FieldValues> extends UseControllerProps<T> {
  error?: FieldError | undefined;
  label: string;
  isDirty?: boolean;
  disabled?: boolean;
  min?: string;
  max?: string;
}

export const TimePicker = <T extends FieldValues>({
  name,
  defaultValue,
  label,
  control,
  error,
  isDirty,
  disabled,
  rules,
  min,
  max,
  ...rest
}: CampaignDateTimePickerProps<T>): JSX.Element => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    rules={rules}
    render={({ field }) => (
      <TextField
        {...rest}
        disabled={disabled}
        error={!!error && isDirty}
        helperText={error?.message}
        label={label}
        type="time"
        // Allow setting min/max values in case the field is not disabled.
        inputProps={{
          ...(!disabled && min && { min }),
          ...(!disabled && max && { max }),
        }}
        variant="outlined"
        {...field}
        InputLabelProps={{
          shrink: true,
        }}
      />
    )}
  />
);
